// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.document

import org.multipaz.cbor.DataItem
import org.multipaz.document.SchemaV0DocumentData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr

internal fun SchemaV0DocumentData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "EwhgOyCNPtg__3-0UoOivbJy2qry9re9y6t10sUAfiw")
internal val SchemaV0DocumentData_cborSchemaId = ByteString(19, 8, 96, 59, 32, -115, 62, -40, 63, -1, 127, -76, 82, -125, -94, -67, -78, 114, -38, -86, -14, -10, -73, -67, -53, -85, 117, -46, -59, 0, 126, 44)

internal fun SchemaV0DocumentData.Companion.fromCbor(data: ByteArray): SchemaV0DocumentData {
    return SchemaV0DocumentData.fromDataItem(Cbor.decode(data))
}

internal val SchemaV0DocumentData.Companion.cborSchemaId: ByteString
    get() = SchemaV0DocumentData_cborSchemaId

internal fun SchemaV0DocumentData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("provisioned", this.provisioned.toDataItem())
    val displayName = this.displayName
    if (displayName != null) {
        builder.put("displayName", Tstr(displayName))
    }
    val typeDisplayName = this.typeDisplayName
    if (typeDisplayName != null) {
        builder.put("typeDisplayName", Tstr(typeDisplayName))
    }
    val cardArt = this.cardArt
    if (cardArt != null) {
        builder.put("cardArt", Bstr(cardArt.toByteArray()))
    }
    val issuerLogo = this.issuerLogo
    if (issuerLogo != null) {
        builder.put("issuerLogo", Bstr(issuerLogo.toByteArray()))
    }
    val authorizationData = this.authorizationData
    if (authorizationData != null) {
        builder.put("authorizationData", Bstr(authorizationData.toByteArray()))
    }
    val other = this.other
    if (other != null) {
        builder.put("other", Bstr(other.toByteArray()))
    }
    return builder.end().build()
}

internal fun SchemaV0DocumentData.Companion.fromDataItem(dataItem: DataItem): SchemaV0DocumentData {
    val provisioned = dataItem["provisioned"].asBoolean
    val displayName0 = if (dataItem.hasKey("displayName")) {
        dataItem["displayName"].asTstr
    } else {
        null
    }
    val typeDisplayName0 = if (dataItem.hasKey("typeDisplayName")) {
        dataItem["typeDisplayName"].asTstr
    } else {
        null
    }
    val cardArt0 = if (dataItem.hasKey("cardArt")) {
        dataItem["cardArt"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val issuerLogo0 = if (dataItem.hasKey("issuerLogo")) {
        dataItem["issuerLogo"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val authorizationData0 = if (dataItem.hasKey("authorizationData")) {
        dataItem["authorizationData"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val other0 = if (dataItem.hasKey("other")) {
        dataItem["other"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    return SchemaV0DocumentData(
        provisioned = provisioned,
        displayName = displayName0,
        typeDisplayName = typeDisplayName0,
        cardArt = cardArt0,
        issuerLogo = issuerLogo0,
        authorizationData = authorizationData0,
        other = other0,
    )
}
